<template>
  <div>
    <el-form
        ref="form"
        v-loading="contentLoading"
        style="min-height: 80vh"
        :model="employees"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="基本信息" name="first">
          <el-form-item label="编号">
            <el-input v-model="employees.employeeNO" style="width: 25%;" disabled placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="employees.employeeName" style="width: 25%;" disabled placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="性别">
            <div style="display: flex;flex-direction: row;width: 25%;">
              <el-select v-model="employees.gender" disabled clearable placeholder="请选择">
                <el-option
                    v-for="item in genders"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="部门">
            <el-input v-model="employees.departmentName" style="width: 25%;" disabled placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="职位">
            <el-input v-model="employees.postName" style="width: 25%;" disabled placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="employees.telephone" style="width: 25%;" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="手机">
            <el-input v-model="employees.mobile" style="width: 25%;" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="employees.email" style="width: 25%;" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="生日">
            <el-date-picker
                v-model="employees.birthday"
                align="right"
                type="date"
                style="width: 25%;"
                placeholder="选择日期"
                :picker-options="pickerOptions"/>
          </el-form-item>
          <el-form-item label="邮编">
            <el-input v-model="employees.postCode" style="width: 25%;" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="employees.address" style="width: 35%;" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="备注">
            <textarea v-model="employees.note" style="width: 35%;" placeholder="请输入"/>
          </el-form-item>
          <span>
            <el-button :loading="submitLoading" type="primary" @click="handleSubmit">
              保存
            </el-button>
          </span>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    components: {},
    data() {
      return {
        constant,
        genders:constant.toSelect(constant.gender),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        activeName: "first",
        employees: {
          employeeID: "",
          employeeNO: "",
          employeeName: "",
          gender: "",
          departmentID: "",
          departmentName: "",
          postID: "",
          postName: "",
          birthday: "",
          telephone: "",
          mobile: "",
          address: "",
          email: "",
          postCode: "",
          note: "",
          id: 90,
          oldPassword: "",
          newPassword: "",
          confirmPd: "",
        },
        ruleValidate: {
          oldPassword: {required: true, message: "不能为空",trigger: "blur"},
          newPassword: {required: true, message: "不能为空",trigger: "blur"},
          confirmPd: {required: true, message: "不能为空",trigger: "blur"},
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [{
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          }, {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          }, {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          }],
        },
      };
    },
    mounted() {
      this.getMessage();
    },
    methods: {
      getMessage() {
        this.$http
          .get("basic", "employees/employeeInfo")
          .then(resp => {
            console.log(resp);
            this.employees = resp;
          });
      },
      handleSubmit() {
        this.submitLoading = true;
        this.$http
          .put("basic", "employees", this.employees)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      handleSubmits() {
        if(this.employees.oldPassword === this.employees.newPassword) {
          this.$message.error("您的新密码与原密码一致，无需更改");
        }else if(this.employees.newPassword !== this.employees.confirmPd) {
          this.$message.error("请统一新密码");
        }else {
          this.$refs.form.validate(valid => {
            if (valid) {
              this.submitLoading = true;
              this.$http
                .put("basic", "system/user/updatePassword", this.employees)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          });
        }
      },
    },
  };
</script>

<style scoped>

</style>
